import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromIssueStore from './reducers/issue-store.reducer';
import { EffectsModule } from '@ngrx/effects';
import { IssueStoreEffects } from './effects/issue-store.effects';
import { IssueService } from '../issue-store/services/issue.service';
import { IssueStoreFacade } from './facades/issue-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromIssueStore.issueStoreFeatureKey,
      fromIssueStore.reducer
    ),
    EffectsModule.forFeature([IssueStoreEffects]),
  ],
  providers: [IssueService, IssueStoreFacade],
})
export class IssueStoreModule {}
